import logoMin from '@assets/images/logo-min.svg';

/**
 * This file contains configuration for Google Shopping Agent, keyed by tenant ID.
 * Each tenant ID maps to an object that can contain various configuration options.
 * Example:
 * Jw0MH5v6LH7nCA8K: {
    disablePrompts: false,
  },
*/

export const googleShoppingAgentConfigs = {
  Jw0MH5v6LH7nCA8K: {
    disablePrompts: false,
  },
  cc4mas9rxqy4x7xh: {
    settings: {
      'chat-title': 'Grocery & Food Assistant',
      'chat-title-icon': logoMin.src,
    },
    style: {
      '--chat-messenger-internal-titlebar-icon-width': '28px',
      '--chat-messenger-internal-titlebar-icon-height': '28px',
      '--chat-messenger-internal-input-content-wrapper-padding-top': '0px',
      '--chat-messenger-internal-input-content-wrapper-padding-right': '0px',
      '--chat-messenger-internal-input-content-wrapper-padding-bottom': '0px',
      '--chat-messenger-internal-input-content-wrapper-padding-left': '8px',
      '--chat-messenger-internal-input-box-focus-border': '1px solid #222222',
      '--md-filled-icon-button-container-height': '48px',
      '--md-filled-icon-button-container-width': '48px',
      '--chat-messenger-color--secondary': '#FFB800',
    },
    components: {
      hero: {
        payload: {
          heroImage:
            'https://images.contentstack.io/v3/assets/bltc8d4068062204b3a/' +
            'bltd36abe90100acf73/68ac4acc12dfd73756f6ee13/photo-1750461326074-f3ee4a041fb2_c_fill_w_1280_h_400.jpg',
        },
        slot: 'messages-header',
        type: 'custom_template',
        name: 'messenger-chat-hero',
      },
      zeroState: {
        payload: {
          styles: {
            '--df-messenger-prompt-color': '#000000',
            '--df-messenger-prompt-background-color': '#ffe5a5',
            '--df-messenger-prompt-color-hover': '#000000',
            '--df-messenger-prompt-background-color-hover': '#ffedbe',
            '--df-messenger-prompt-icon-size': '24px',
          },
          text: `Hello! I'm your Shopping Assistant.
            From fresh produce to pantry staples, let's find everything you need to fill your kitchen today.`,
          prompts: [ 'Search for organic produce',
            'Quick lunch ideas',
            'High-protein meals', ],
        },
        slot: 'messages-header',
        type: 'custom_template',
        name: 'zero-state',
      },
    },
  },
};
